// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';

import 'regenerator-runtime/runtime';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './setup-axios';
import './setup-googleAnalytics';
import './instrumentation';

if (import.meta.env.MODE === 'development') {
    const { worker } = await import('./mocks/browser');
    worker.start();
}

if (import.meta.env.MODE === 'production') {
    registerSW({ immediate: true });
}

render(<App />, document.getElementById('root'));
